import {CHART_MONTH_TICKFORMAT, LightChartImageDownloadProps, LightChartLayout} from '@wallaby-ui/document';
import {useMemo} from 'react';

import {ChartTypeType} from './departmenttypes';
import {TranslateUtils} from '@wallaby-ui/core';
import {useIntl} from 'react-intl';

export const useDepartmentReportChartConfig = (chartType: ChartTypeType, reportTypeChartTitle: string) => {
  const intl = useIntl();
  const chartLayout: LightChartLayout = useMemo(() => {
    if (chartType === 'LINE_CHART') {
      return {
        margin: {
          b: 42,
        },
        xaxis: {
          type: 'date',
          tickformat: CHART_MONTH_TICKFORMAT,
          automargin: true,
        },
        yaxis: {
          rangemode: 'tozero',
          automargin: true,
          fixedrange: true,
        },
        height: 350,
        showlegend: false,
      };
    }
    return {
      xaxis: {
        type: 'date',
        tickformat: CHART_MONTH_TICKFORMAT,
        automargin: true,
      },
      yaxis: {
        type: 'linear',
        automargin: true,
        fixedrange: true,
      },
      height: 350,
      showlegend: false,
    };
  }, [chartType]);
  const chartImageDownload: LightChartImageDownloadProps = {
    showlegend: true,
    title: {
      text: TranslateUtils.translate(reportTypeChartTitle, intl),
    },
  };

  return {
    chartLayout,
    chartImageDownload,
  };
};
